import React, { useEffect, useState, useCallback, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  Button,
  Container,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Grid,
  Typography,
  Input,
  InputLabel,
  TextField,
  MenuItem,
  FormControl,
  TableCell,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  IconButton,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  TableHead,
  InputAdornment,
} from "@material-ui/core";
import Title from "../../ui/Title";
import { useBmapi } from "../../utils/bmapi-context";
import { useCampaigns } from "../../utils/campaigns";
import { MANAGER_ROUTES } from "../../utils/constants";
import { useParams } from "react-router-dom";
import FormSection from "../../ui/forms/input/FormSection";
import { campaign, common, form, navigation } from "../../messages";
import { DatePicker, TimePicker } from "../../ui/DatePicker";
import { getErrorMessageString } from "../../utils/errors";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { PERIOD_TYPE } from "../../utils/campaignMessagesConstants";
import {
  getArrLabel,
  getMapFields,
  intlFormatMessage,
} from "../../utils/utils";
import { format, parseISO, startOfDay } from "date-fns";
import { parseBmarkenDate } from "../../utils/utils";
import {
  STATS,
  STATUS,
  TASK_ERRORS,
  TASK_RESULTS,
} from "../../utils/settingsConstants";
import { settings } from "../../messages/settings";
import { Info, Error, CheckCircle, Refresh } from "@material-ui/icons";
import FieldMultilang from "../../ui/forms/input/FieldMultilang";
import MessageAutomaticDistribution from "../../components/MessageAutomaticDistribution";
import ImagePreview from "../../components/ImagePreview";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

function formatTime(isoString) {
  if (!isoString) return "";
  const date = parseISO(isoString);
  return format(date, "dd/MM/yyyy HH:mm:ss");
}
function Navigation() {
  const intl = useIntl();

  return (
    <FormControl margin="normal" fullWidth>
      <Grid container direction="row" alignItems="flex-start" spacing={1}>
        <Grid item>
          <Button
            component={RouterLink}
            to={MANAGER_ROUTES.MESSAGES_CAMPAIGNS.replace(":campaignId", "")}
            startIcon={<ArrowBack />}
          >
            {intl.formatMessage(common.backMessages)}
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={RouterLink}
            to={MANAGER_ROUTES.HOME}
            startIcon={<ArrowForward />}
          >
            {intl.formatMessage(navigation.goHome)}
          </Button>
        </Grid>
      </Grid>
    </FormControl>
  );
}

function initValues() {
  return {
    /*campaignName: "", */ title: "",
    body: "",
    app_link_label: "",
    app_link_uri: "",
    image_url: "",
    thumb_url: "",
    link_uri: "",
    body_format: "",
    auto_distr: "",
  };
}
function initDistrValues() {
  return { listId: "" };
}

export default function Campaigns() {
  const {
    bmapi,
    businessId,
    startLoading,
    stopLoading,
    notifySuccess,
    notifyError,
  } = useBmapi();
  const history = useHistory();
  const { campaigns, loadCampaigns } = useCampaigns();
  const { messageId } = useParams();
  const [values, setValues] = useState(initValues());
  const [distrValues, setDistrValues] = useState(initDistrValues());
  const intl = useIntl();
  const today = new Date();
  const [campaignSelected, setCampaignSelected] = React.useState("");
  const [messageStatus, setMessageStatus] = React.useState(null);
  const clone = location.href.includes("clone");
  const [targets, setTargets] = useState([]);
  // tasks
  const [taskId, setTaskId] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [taskStats, setTaskStats] = useState([]);
  const [taskErrors, setTaskErrors] = useState([]);
  const [open, setOpen] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [imgCmpDialog, setImgCmpDialog] = useState({
    open: false,
    title: "",
    url: "",
    targetField: "",
  });

  useEffect(() => {
    !campaigns ? startLoading() : stopLoading();
  }, [campaigns, startLoading, stopLoading]);

  // multilang start

  const defaultLanguage = bmapi.settings.language?.default || "en";
  const availableLanguages = bmapi.settings.language?.other || [];

  const initLngValues = (initLangValues) => {
    const res = {
      title: getMapFields(initLangValues, "title", "lang"),
      body: getMapFields(initLangValues, "body", "lang"),
    };
    return res;
  };

  const [valuesLng, setValuesLng] = useState(initLngValues([]));

  const handleValuesLng = useCallback(
    (varName) => (lang) => (e) => {
      const value = valuesLng[varName];
      const text = e.target.value;
      value.set(lang, text);
      const newValuesLng = { ...valuesLng, [varName]: value };
      setValuesLng(newValuesLng);
    },
    [valuesLng]
  );

  const createLocalizedObj = () => {
    const localizedObj = [];
    for (let i = 0; i < availableLanguages.length; ++i) {
      localizedObj.push({
        title: valuesLng.title?.get(availableLanguages[i]) || "",
        body: valuesLng.body?.get(availableLanguages[i]) || "",
        app_link_label:
          valuesLng.app_link_label?.get(availableLanguages[i]) || "",

        lang: availableLanguages[i],
      });
    }
    return localizedObj;
  };

  const campaignSelectedObj = useMemo(() => {
    if (!campaigns) return null;
    return campaigns.find((c) => c.campaign_id === campaignSelected) || null;
  }, [campaigns, campaignSelected]);

  const norm = (s) => (typeof s === "string" ? s.trim() : "");

  const openCmpDialog = (title, url, targetField) => {
    setImgCmpDialog({ open: true, title, url, targetField });
  };

  const closeCmpDialog = () => {
    setImgCmpDialog({ open: false, title: "", url: "" });
  };

  const copyDialogUrlToField = () => {
    const { url, targetField } = imgCmpDialog;
    if (!url || !targetField) return;

    setValues((v) => ({
      ...v,
      [targetField]: url,
    }));

    closeCmpDialog();
  };

  const campaignImageUrl = norm(campaignSelectedObj?.campaign_data?.image_url);
  const campaignAvatarUrl = norm(
    campaignSelectedObj?.campaign_data?.avatar_url
  );

  const currentImageUrl = norm(values.image_url);
  const currentThumbUrl = norm(values.thumb_url);

  const imageCmp = !campaignImageUrl
    ? "none"
    : campaignImageUrl === currentImageUrl
    ? "same"
    : "diff";

  const thumbCmp = !campaignAvatarUrl
    ? "none"
    : campaignAvatarUrl === currentThumbUrl
    ? "same"
    : "diff";

  // multilang end
  /*
  useEffect(() => {
    if (campaigns) {
      campaigns.push({
        name: intl.formatMessage(campaign.noCampaign),
        campaign_id: "-",
        business_name: "",
        isActive: true,
      });
      bmapi
        .getMessagesCampaign()
        .then((messages) => {
          setMessageStatus(messages[0].message.status);
          const msgObj = messages.find((x) => x.message.id == messageId);
          const campaignId =
            campaigns.find(
              (x) => x.campaign_id == msgObj.message.campaign_id
            ) == undefined
              ? "-"
              : campaigns.find(
                  (x) => x.campaign_id == msgObj.message.campaign_id
                ).campaign_id;
          setValues({
            campaign_id: campaignId,
            title: msgObj.message.title,
            body: msgObj.message.body,
            banner: msgObj.mobile_config.banner,
            banner_close: !!msgObj.mobile_config.banner_close_mode,
            banner_close_mode: msgObj.mobile_config.banner_close_mode,

            banner_close_date: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            close_date: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            close_time: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            banner_close_number: msgObj.mobile_config.banner_close_number || "",
            push_notification: msgObj.mobile_config.push_notification,
            expire_at: msgObj.message.expire_at.substring(0, 10),
            app_link_label: msgObj.message.app_link_label,
            app_link_uri: msgObj.message.app_link_uri,
            image_url: msgObj.message.image_url,
            link_uri: msgObj.mobile_config.link_uri,
          });
          setCampaignSelected(campaignId);
          stopLoading();
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
          stopLoading();
        });
    }
    // eslint-disable-next-line
  }, [campaigns]);
*/
  useEffect(() => {
    if (campaigns) {
      campaigns.push({
        name: intl.formatMessage(campaign.noCampaign),
        campaign_id: "-",
        business_name: "",
        isActive: true,
      });
      bmapi
        .getMessageDetails(messageId)
        .then((message) => {
          const msgObj = message;
          setMessageStatus(msgObj.message.status);
          const campaignId = msgObj.message.campaign_id || "-";
          setValues({
            campaign_id: campaignId,
            title: msgObj.message.title,
            body: msgObj.message.body,
            banner: msgObj.mobile_config.banner,
            banner_close: !!msgObj.mobile_config.banner_close_mode,
            banner_close_mode: msgObj.mobile_config.banner_close_mode,

            banner_close_date: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            close_date: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            close_time: parseBmarkenDate(
              msgObj.mobile_config.banner_close_date
            ),
            banner_close_number: msgObj.mobile_config.banner_close_number || "",
            push_notification: msgObj.mobile_config.push_notification,
            expire_at: msgObj.message.expire_at.substring(0, 10),
            app_link_label: msgObj.message.app_link_label,
            app_link_uri: msgObj.message.app_link_uri,
            image_url: msgObj.message.image_url,
            thumb_url: msgObj.message.thumb_url,
            link_uri: msgObj.mobile_config.link_uri,
            body_format: msgObj.message.body_format,
            auto_distr: msgObj.message.auto_distr,
          });
          setCampaignSelected(campaignId);
          setValuesLng(initLngValues(msgObj.localized));
          stopLoading();
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
          stopLoading();
        });
    }
    // eslint-disable-next-line
  }, [campaigns]);

  const loadTasks = useCallback(() => {
    if (!messageId) return;

    startLoading();

    bmapi
      .getTasks({ processRef: messageId })
      .then((resp) => {
        if (!resp) {
          resp = [];
        }
        setTasks(resp);
      })
      .catch((e) => {
        notifyError(getErrorMessageString(e, intl));
      })
      .finally(() => {
        stopLoading();
      });
  }, [
    messageId,
    startLoading,
    stopLoading,
    bmapi,
    setTasks,
    notifyError,
    intl,
  ]);

  // get task descriptors
  useEffect(() => {
    loadTasks();
  }, [loadTasks]);

  const handleChange = useCallback((label) => {
    const updateValue = (val) => {
      setValues((v) => ({ ...v, [label]: val }));
    };

    return (i, f) => {
      if (typeof f === "boolean") {
        if ((label === "banner" || label === "banner_close") && !f) {
          updateValue(false);
          setValues((v) => ({
            ...v,
            banner_close: false,
            banner_close_mode: "DAY",
            //banner_close_date: format(new Date(), "yyyy-MM-dd"),
            /*banner_close_date: format(new Date(), "yyyy-MM-dd00:00").replace(
              /(\d{4}-\d{2}-\d{2})(\d{2}:\d{2})/,
              "$1T$2"
            ),*/
            banner_close_date: "",
            close_date: new Date(),
            close_time: startOfDay(new Date()),
            banner_close_number: 1,
          }));
        } else {
          updateValue(f);
        }
      } else if (i?.target) {
        updateValue(i.target.value);
      } else {
        updateValue(i);
      }
    };
  }, []);

  const handleDistrChange = useCallback((label) => {
    const updateValue = (val) => {
      setDistrValues((v) => ({ ...v, [label]: val }));
    };
    return (i) => {
      if (label === "listId") {
        updateValue(i.target.value);
      } else {
        updateValue(i);
      }
    };
  }, []);

  const handleChangeCampaign = (event) => {
    setCampaignSelected(event.target.value);
  };

  useEffect(() => {
    loadCampaigns();
  }, [loadCampaigns]);

  useEffect(() => {
    bmapi
      .getMessageTargets()
      .then((targets) =>
        setTargets((targets || []).sort((a, b) => a.name.localeCompare(b.name)))
      )
      .catch((e) => notifyError(getErrorMessageString(e, intl)));
  }, [notifyError, intl, bmapi]);

  const isDate = values.banner_close_mode === "DAY";

  function fields() {
    return (
      <div style={{ minHeight: "300px" }}>
        <FormSection>
          {/*
        <FormControl fullWidth margin="normal">
          <InputLabel>{intl.formatMessage(form.title)}</InputLabel>
          <Input
            name="title"
            type="text"
            value={values.title}
            onChange={handleChange("title")}
            key="title"
            fullWidth
            required
          />
        </FormControl>*/}
          <FieldMultilang
            name="title"
            label={intl.formatMessage(form.title)}
            value={values.title}
            onChange={handleChange("title")}
            key="title"
            fullWidth
            margin="normal"
            required
            defaultLanguage={defaultLanguage}
            availableLanguages={availableLanguages}
            valuesLng={valuesLng["title"]}
            handleValuesLng={handleValuesLng("title")}
          />
          {/*
        <FormControl fullWidth margin="normal">
          <Typography className="MuiFormLabel-root" gutterBottom>
            {intl.formatMessage(common.text)}
          </Typography>
          <TextareaAutosize
            name="body"
            value={values.body}
            onChange={handleChange("body")}
            key="body"
            style={{
              width: "100%",
              height: "200px",
            }}
            aria-label="maximum height"
            placeholder={intl.formatMessage(form.insertMessage)}
          />
        </FormControl>*/}
          <FieldMultilang
            name="body"
            label={intl.formatMessage(common.text)}
            value={values.body}
            onChange={handleChange("body")}
            key="body"
            fullWidth
            margin="normal"
            required
            defaultLanguage={defaultLanguage}
            availableLanguages={availableLanguages}
            valuesLng={valuesLng["body"]}
            handleValuesLng={handleValuesLng("body")}
            multiline
            placeholder={intl.formatMessage(form.insertMessage)}
            hasFormat={true}
            formatValue={values.body_format}
            onFormatChange={handleChange("body_format")}
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!values.banner}
                  onChange={handleChange("banner")}
                  inputProps={{ "aria-label": "controlled" }}
                  color="primary"
                />
              }
              label={intl.formatMessage(form.banner)}
            />
            {values.banner && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.banner_close}
                    onChange={handleChange("banner_close")}
                    color="primary"
                  />
                }
                label={intl.formatMessage(form.bannerClose)}
              />
            )}
          </FormGroup>
          {values.banner_close && (
            <>
              <TextField
                margin="normal"
                autoFocus
                label={intl.formatMessage(form.selectPeriod)}
                value={values.banner_close_mode}
                onChange={handleChange("banner_close_mode")}
                fullWidth
                select
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {PERIOD_TYPE.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {intlFormatMessage(
                      common[option.label],
                      option.label,
                      intl
                    )}
                  </MenuItem>
                ))}
              </TextField>
              {isDate ? (
                <>
                  <DatePicker
                    label={intl.formatMessage(form.selectDate)}
                    value={values.close_date}
                    onChange={handleChange("close_date")}
                    fullWidth
                    margin="normal"
                    required
                    clearable
                  />
                  <TimePicker
                    label={intl.formatMessage(form.selectTime)}
                    value={values.close_time}
                    onChange={handleChange("close_time")}
                    fullWidth
                    margin="normal"
                    clearable
                  />
                </>
              ) : (
                <TextField
                  required
                  margin="normal"
                  label={intl.formatMessage(form.insertQuantity)}
                  fullWidth
                  autoFocus
                  type="number"
                  value={values.banner_close_number}
                  onChange={handleChange("banner_close_number")}
                  onInput={(e) => {
                    e.target.value =
                      e.target.value !== ""
                        ? e.target.value === "0"
                          ? e.target.value.replace(/^[0]|[^0-9]/g, "")
                          : +e.target.value.replace(/^[0]|[^0-9]/g, "")
                        : e.target.value;
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: "1",
                  }}
                />
              )}
            </>
          )}
          {/*
        {values.banner_close && (
          <Box display="flex">
            <TextField
              margin="normal"
              autoFocus
              label={intl.formatMessage(form.selectPeriod)}
              value={values.banner_close_mode}
              onChange={handleChange("banner_close_mode")}
              fullWidth
              select
              InputLabelProps={{
                shrink: true,
              }}
            >
              {PERIOD_TYPE.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {intlFormatMessage(common[option.label], option.label, intl)}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              required
              margin="normal"
              label={
                isDate
                  ? intl.formatMessage(form.selectDate)
                  : intl.formatMessage(form.insertQuantity)
              }
              fullWidth
              autoFocus
              type={isDate ? "datetime-local" : "number"}
              value={
                isDate ? values.banner_close_date : values.banner_close_number
              }
              onChange={
                isDate
                  ? handleChange("banner_close_date")
                  : handleChange("banner_close_number")
              }
              onInput={
                isDate
                  ? false
                  : (e) => {
                      e.target.value =
                        e.target.value !== ""
                          ? e.target.value === "0"
                            ? e.target.value.replace(/^[0]|[^0-9]/g, "")
                            : +e.target.value.replace(/^[0]|[^0-9]/g, "")
                          : e.target.value;
                    }
              }
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: "1",
              }}
            />
          </Box>
        )}
        */}

          <FormControlLabel
            control={
              <Checkbox
                checked={!!values.push_notification}
                onChange={handleChange("push_notification")}
                inputProps={{ "aria-label": "controlled" }}
                color="primary"
              />
            }
            label={intl.formatMessage(form.pushNotification)}
          />
          <DatePicker
            minDate={today}
            margin="dense"
            fullWidth
            label="Expire At"
            format="yyyy-MM-dd"
            value={values.expire_at === "0001-01-01" ? null : values.expire_at}
            onChange={handleChange("expire_at")}
          />
        </FormSection>

        <FormSection title="Immagini">
          {/* IMAGE URL */}
          <FormControl fullWidth margin="dense">
            <InputLabel htmlFor="image_url">Image URL</InputLabel>

            <Input
              id="image_url"
              name="image_url"
              value={values.image_url || ""}
              onChange={handleChange("image_url")}
              fullWidth
              endAdornment={
                <InputAdornment position="end">
                  {imageCmp === "same" && (
                    <CheckCircleIcon
                      style={{ color: "green" }}
                      titleAccess="URL coincide"
                    />
                  )}

                  {imageCmp === "diff" && (
                    <>
                      <WarningIcon
                        style={{ color: "#fbc02d" }}
                        titleAccess="URL diverso"
                      />
                      <Box ml={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() =>
                            openCmpDialog(
                              "Immagine campagna",
                              campaignImageUrl,
                              "image_url"
                            )
                          }
                        >
                          Visualizza
                        </Button>
                      </Box>
                    </>
                  )}
                </InputAdornment>
              }
            />

            <ImagePreview url={values.image_url} alt="Image preview" />
          </FormControl>

          {/* THUMB URL */}
          <FormControl fullWidth margin="dense">
            <InputLabel htmlFor="thumb_url">Thumb URL</InputLabel>

            <Input
              id="thumb_url"
              name="thumb_url"
              value={values.thumb_url || ""}
              onChange={handleChange("thumb_url")}
              fullWidth
              endAdornment={
                <InputAdornment position="end">
                  {thumbCmp === "same" && (
                    <CheckCircleIcon
                      style={{ color: "green" }}
                      titleAccess="URL coincide"
                    />
                  )}

                  {thumbCmp === "diff" && (
                    <>
                      <WarningIcon
                        style={{ color: "#fbc02d" }}
                        titleAccess="URL diverso"
                      />
                      <Box ml={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() =>
                            openCmpDialog(
                              "Avatar campagna",
                              campaignAvatarUrl,
                              "thumb_url"
                            )
                          }
                        >
                          Visualizza
                        </Button>
                      </Box>
                    </>
                  )}
                </InputAdornment>
              }
            />

            <ImagePreview
              url={values.thumb_url}
              alt="Thumb preview"
              height={100}
            />
          </FormControl>
        </FormSection>

        <FormSection
          title={intl.formatMessage({
            id: "label.linkAndUrl",
            defaultMessage: "Link",
          })}
          collapsed={true}
        >
          <FormControl fullWidth margin="dense">
            <InputLabel>App Link Label</InputLabel>
            <Input
              name="app_link_label"
              value={values.app_link_label}
              onChange={handleChange("app_link_label")}
              key="app_link_label"
            />
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel>App Link URI</InputLabel>
            <Input
              name="app_link_uri"
              value={values.app_link_uri}
              onChange={handleChange("app_link_uri")}
              key="app_link_uri"
            />
          </FormControl>

          <FormControl fullWidth margin="dense">
            <InputLabel>Link URI</InputLabel>
            <Input
              name="link_uri"
              value={values.link_uri}
              onChange={handleChange("link_uri")}
              key="link_uri"
            />
          </FormControl>
        </FormSection>

        <MessageAutomaticDistribution
          value={values.auto_distr}
          onChange={handleChange("auto_distr")}
        />
      </div>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    startLoading();
    //const client_id = "16d4c11d-1798-4217-8834-d0fe37a4c49c";
    const client_id = "";
    const campaign_id = campaignSelected;

    if (!values.banner_close) {
      values.banner_close_mode = "";
      values.banner_close_date = "";
      values.banner_close_number = "";
    } else {
      if (values.close_time) {
        values.banner_close_date = `${format(
          values.close_time,
          "yyyy-MM-dd"
        )}T${format(values.close_time, "HH:mm:00")}`;
      } else if (values.close_date) {
        values.banner_close_date = `${format(
          values.close_date,
          "yyyy-MM-dd"
        )}T00:00:00`;
      }
    }

    delete values.close_date;
    delete values.close_time;

    const localized = createLocalizedObj();

    if (!clone) {
      return bmapi
        .updateMessageCampaign(
          values.title,
          values.body,
          values.banner,
          values.banner_close_mode,
          values.banner_close_mode === "DAY" ? values.banner_close_date : "",
          values.banner_close_mode === "DAY" ? 0 : +values.banner_close_number,
          values.push_notification,
          values.expire_at instanceof Date
            ? values.expire_at.toISOString().substring(0, 10)
            : values.expire_at,
          values.app_link_label,
          values.app_link_uri,
          values.image_url,
          values.thumb_url,
          values.link_uri,
          messageId,
          client_id,
          campaign_id === "-" ? "" : campaign_id,
          values.body_format,
          values.auto_distr,
          localized
        )
        .then(() => {
          notifySuccess(
            intl.formatMessage({
              id: "pages.messageCampaign.update",
              defaultMessage: "Messaggio aggiornato con successo",
            })
          );
          stopLoading();
          history.push(
            MANAGER_ROUTES.MESSAGES_CAMPAIGNS.replace(":campaignId?/", "")
          );
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
          stopLoading();
        });
    } else {
      return bmapi
        .saveMessageCampaign(
          values.title,
          values.body,
          values.banner,
          values.banner_close_mode,
          values.banner_close_mode === "DAY" ? values.banner_close_date : "",
          values.banner_close_mode === "DAY" ? 0 : +values.banner_close_number,
          values.push_notification,
          values.expire_at instanceof Date
            ? values.expire_at.toISOString().substring(0, 10)
            : values.expire_at,
          values.app_link_label,
          values.app_link_uri,
          values.image_url,
          values.link_uri,
          campaign_id === "-" ? "" : campaign_id,
          client_id,
          values.body_format,
          values.auto_distr,
          localized
        )
        .then(() => {
          notifySuccess(
            intl.formatMessage({
              id: "pages.messageCampaign.create",
              defaultMessage: "Messaggio creato con successo",
            })
          );
          history.push(
            MANAGER_ROUTES.MESSAGES_CAMPAIGNS.replace(":campaignId?/", "")
          );
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
          //stopLoading();
        })
        .finally(stopLoading);
    }
  };

  const handleSubmitDistr = async (e) => {
    if (messageId == null) return;

    if (!distrValues.listId) {
      notifyError("Specificare la lista di distribuzione");
      return;
    }

    e.preventDefault();
    startLoading();

    const selectedTarget = targets.find((t) => t.id === distrValues.listId);
    const is_crm = !!selectedTarget?.is_crm;

    bmapi
      .startDistribution(messageId, distrValues.listId, is_crm)
      .then(() => {
        stopLoading();
        notifySuccess("Messaggio accodato");
      })
      .catch((e) => {
        stopLoading();
        notifyError(getErrorMessageString(e, intl));
      });
  };

  const showTask = (id) => {
    setTaskId(id);

    if (bmapi) {
      startLoading();
      bmapi
        .getTaskStats({ task: id })
        .then((resp) => {
          if (!resp) {
            resp = [];
          }
          setTaskStats(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  const getResult = (i, varName, id) => {
    if (varName.value === "status") {
      const label = getArrLabel(STATUS, tasks[i][varName.value]);

      return label === "running" || label === "executedErrors" ? (
        <React.Fragment>
          {intlFormatMessage(common[label], label, intl)}
          <IconButton
            size="small"
            onClick={() => {
              showTask(id);
              setOpen(true);
            }}
          >
            <Info />
          </IconButton>
        </React.Fragment>
      ) : (
        intlFormatMessage(common[label], label, intl)
      );
    }

    if (id) return tasks[i][varName.value] || "-";
    else return taskErrors[i][varName.value] || "-";
  };

  const getStatus = (status, taskDescrId) => {
    return (
      <Box display="flex" alignItems="center">
        {status === "RUNNING" && (
          <IconButton
            size="small"
            onClick={() => {
              showTask(taskDescrId);
              setOpen(true);
            }}
          >
            <Info />
          </IconButton>
        )}
        {status === "EXECUTED-W-ERRORS" && (
          <IconButton
            size="small"
            onClick={() => {
              showTask(taskDescrId);
              setOpen(true);
            }}
          >
            <Error />
          </IconButton>
        )}
        {status === "SUCCESSFULLY-EXECUTED" && (
          <IconButton
            size="small"
            onClick={() => {
              showTask(taskDescrId);
              setOpen(true);
            }}
          >
            <CheckCircle />
          </IconButton>
        )}
        {status}
      </Box>
    );
  };

  const getErrors = () => {
    setShowErrors(!showErrors);

    if (bmapi && taskErrors.length === 0) {
      startLoading();
      bmapi
        .getTaskErrors({ task: taskId })
        .then((resp) => {
          if (!resp) {
            resp = [];
          }
          setTaskErrors(resp);
        })
        .catch((e) => {
          notifyError(getErrorMessageString(e, intl));
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  function ResultsTable({ arr }) {
    return (
      <React.Fragment>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell component="th">
                  {intlFormatMessage(settings.dateTimeError, "", intl)}
                </TableCell>
                <TableCell component="th">
                  {intlFormatMessage(settings.status, "", intl)}
                </TableCell>
                <TableCell component="th">
                  {intlFormatMessage(settings.queueStatus, "", intl)}
                </TableCell>
                <TableCell component="th">
                  {intlFormatMessage(settings.targetCount, "", intl)}
                </TableCell>
                <TableCell component="th">
                  {intlFormatMessage(settings.errorsCount, "", intl)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arr.map((element, i) => (
                <TableRow key={"row" + i}>
                  <TableCell component="td">
                    {/*format(element.created_at, "dd/MM/yyyy")*/}
                    {formatTime(element.created_at)}
                  </TableCell>
                  <TableCell component="td">
                    {getStatus(element.status, element.id)}
                  </TableCell>
                  <TableCell component="td">{element.queue_status}</TableCell>
                  <TableCell component="td">{element.items_count}</TableCell>
                  <TableCell component="td">{element.errors_count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    );
  }

  return !businessId ? (
    <Container maxWidth="md" className="tablistNone"></Container>
  ) : campaigns ? (
    <Container maxWidth="sm">
      <Title>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box>
            <FormattedMessage
              id="pages.messageCampaigns.edit"
              defaultMessage="Modifica Messaggio"
            />
          </Box>
        </Box>
      </Title>

      <FormSection>
        <TextField
          disabled={messageStatus !== 0}
          select
          label={intl.formatMessage(common.campaign)}
          value={campaignSelected}
          onChange={handleChangeCampaign}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {campaigns
            .filter((s) => s.isActive)
            .map((option) => (
              <MenuItem key={option.name} value={option.campaign_id}>
                {option.name}
              </MenuItem>
            ))}
        </TextField>
      </FormSection>

      <form onSubmit={handleSubmit}>
        {fields()}
        <Button variant="contained" fullWidth color="primary" type="submit">
          {intl.formatMessage(common.save)}
        </Button>
      </form>
      <Container maxWidth="sm" className="tablistNone">
        <Title>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            <Box>Distribuzione</Box>
          </Box>
        </Title>
        <form onSubmit={handleSubmitDistr}>
          <FormSection>
            <TextField
              select
              label="Lista di distribuzione"
              value={distrValues.listId}
              onChange={handleDistrChange("listId")}
              InputLabelProps={{ shrink: true }}
              fullWidth
              required
            >
              {targets?.map((t) => (
                <MenuItem key={t.id} value={t.id}>
                  {t.name}
                </MenuItem>
              ))}

              {!targets?.length && (
                <MenuItem value="" disabled>
                  Nessun target disponibile
                </MenuItem>
              )}
            </TextField>
          </FormSection>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            type="submit"
            disabled={!distrValues.listId}
          >
            Invia Distribuzione
          </Button>
        </form>
      </Container>
      <Container maxWidth="sm" className="tablistNone">
        <Title>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            <Box>Distribuzioni effettuate</Box>
            <IconButton size="small" onClick={loadTasks}>
              <Refresh />
            </IconButton>
          </Box>
        </Title>
        {/* TASK TABLE */}
        {tasks.length !== 0 && (
          <ResultsTable
            arr={tasks}
            constArr={TASK_RESULTS}
            getResult={getResult}
            useId={true}
          />
        )}
        {tasks.length === 0 && (
          <Box mt={2}>
            <Typography>
              {intl.formatMessage(common.noElementToShow)}
            </Typography>
          </Box>
        )}
      </Container>
      {/* POP UP ESECUZIONE TASK */}
      {taskStats.length !== 0 && (
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={() => {
            setOpen(false);
            setTaskStats([]);
            setTaskId(null);
            setTaskErrors([]);
          }}
        >
          <DialogTitle>Dettagli distribuzione</DialogTitle>
          <DialogContent>
            <Box>
              <Typography fontWeight="bold">ID: {taskId}</Typography>
            </Box>
            <TableContainer>
              <Table size="small">
                <TableBody>
                  {Object.entries(taskStats).map((t) => (
                    <TableRow key={t[0]}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ fontWeight: 500 }}
                      >
                        {getArrLabel(STATS, t[0])}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {t[1]}
                      </TableCell>
                      <TableCell align="right">
                        {t[0] === "Errors" && t[1] > 0 && (
                          <Button onClick={getErrors} variant="contained">
                            {intl.formatMessage(settings.showErrors)}
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpen(false);
                setTaskStats([]);
                setTaskId(null);
                setTaskErrors([]);
              }}
              color="primary"
            >
              {intl.formatMessage(common.close)}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* POP UP TASK TABLE ERRORS */}
      {showErrors && (
        <Dialog
          fullWidth
          maxWidth="sm"
          open={showErrors}
          onClose={() => {
            setShowErrors(false);
          }}
        >
          <DialogTitle>{intl.formatMessage(settings.executing)}</DialogTitle>
          <DialogContent>
            <ResultsTable
              arr={taskErrors}
              constArr={TASK_ERRORS}
              getResult={getResult}
              useId={false}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setShowErrors(false);
              }}
              color="primary"
            >
              {intl.formatMessage(common.close)}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Dialog
        fullWidth
        maxWidth="sm"
        open={imgCmpDialog.open}
        onClose={closeCmpDialog}
      >
        <DialogTitle>{imgCmpDialog.title}</DialogTitle>
        <DialogContent>
          <ImagePreview
            url={imgCmpDialog.url}
            alt={imgCmpDialog.title}
            variant="dialog"
            maxHeight="70vh"
            maxWidth="100%"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCmpDialog} color="primary">
            {intl.formatMessage(common.close)}
          </Button>
          <Button
            onClick={copyDialogUrlToField}
            color="primary"
            variant="contained"
            disabled={!imgCmpDialog.url || !imgCmpDialog.targetField}
          >
            Copia
          </Button>
        </DialogActions>
      </Dialog>

      <Navigation />
    </Container>
  ) : null;
}
